import { TEACHER_GUIDE_ACTIONS } from 'app/store/actions/teacher-guide.actions'
import baseRequestReducer from 'app/store/reducers/base-request.reducer'
import TEACHER_GUIDE from 'app/constants/teacher-guide.constants'
import {
  TeacherGuideInitialState,
  TeacherGuideSectionInfo,
} from 'app/types/teacher-guide-reducers.types'

const initialState: TeacherGuideInitialState = {
  data: [],
  loading: true,
  error: false,
}

const TeacherGuideReducers: Record<
  string,
  ReturnType<typeof baseRequestReducer<TeacherGuideSectionInfo[]>>
> = {}

Object.keys(TEACHER_GUIDE).forEach((key) => {
  TeacherGuideReducers[key] = baseRequestReducer(
    initialState,
    TEACHER_GUIDE_ACTIONS[key as keyof typeof TEACHER_GUIDE_ACTIONS]
  )
})

export default TeacherGuideReducers
